export default {
  ALBUM_FILE_GENERATED: 'album-file-generated',
  ALBUM_FILE_NOT_GENERATED: 'album-file-not-generated',
  POST_IMPORT_COMPLETE: 'post-import-complete',
  POST_SEARCH_COMPLETE: 'post-search-complete',
  USER_ACTIVATED: 'user-activated',
  REPORT_FILE_GENERATED: 'report-file-generated',
  REPORT_FILE_NOT_GENERATED: 'report-file-not-generated',
  SOCIAL_ACCOUNT_AUTHENTICATED: 'social-account-authenticated',
  FACEBOOK_ACCOUNT_AUTHENTICATED: 'facebook-account-authenticated',
  INSTAGRAM_ACCOUNT_AUTHENTICATED: 'instagram-account-authenticated',
  SOCIAL_ACCOUNT_ACCESS_REVOKED: 'social-account-access-revoked',
  SOCIAL_ACCOUNT_DATA_DELETION_REQUESTED: 'social-account-data-deletion-requested',
};
